import React from 'react';
import langConf from "../js/lang";
import BackButton from './BackButton';
//import sheleg from '../api/sheleg';

class FinalOffer extends React.Component {

    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    handleClick = async (event) => {
        event.preventDefault();
        // let itemSum = 0;
        // this.props.finalOfferItems.map((item)=> itemSum += this.props.currency === "ILS" ? (item.priceNis === null ? 0 : (item.priceNis * item.quantity)) : (item.Usd === null ? 0 : (item.priceUsd * item.quantity)));
        // await this.saveNewCart(this.props.finalOfferItems); 
        // if (itemSum === 0 || itemSum === null){
        //     this.props.changeScreen('transactionResult');
        // }
        // else{
        this.props.changeScreen('payment');
        // }
    };

    handleCouponClick = (event) => {
        event.preventDefault();
        if (document.querySelector('#coupon').style.display === 'none') {
            document.querySelector('#coupon').style.display = 'block';
        }
        else {
            document.querySelector('#coupon').style.display = 'none';
        }
    };

    handleCouponSubmitClick = async (event) => {
        event.preventDefault();
        if (document.querySelector('#submitCoupon').classList.value.search('loading') === -1) {
            document.querySelector('#submitCoupon').classList.add('loading');
        }
        else {
            document.querySelector('#submitCoupon').classList.remove('loading');
        }
    };

    NormalizeDate(day, month, year) {
        var finalDate = '';
        var finalMonth = '';
        var finalDay = '';
        if (month + 1 < 10) {
            finalMonth = '0' + (month + 1);
        }
        else {
            finalMonth = month + 1;
        }
        if (day < 10) {
            finalDay = '0' + day;
        }
        else {
            finalDay = day;
        }
        finalDate = '' + year + '-' + finalMonth + '-' + finalDay + '';
        return finalDate;
    }

    NormalizeDateIL(day, month, year) {
        var finalDate = '';
        var finalMonth = '';
        var finalDay = '';
        if (month + 1 < 10) {
            finalMonth = '0' + (month + 1);
        }
        else {
            finalMonth = month + 1;
        }
        if (day < 10) {
            finalDay = '0' + day;
        }
        else {
            finalDay = day;
        }
        finalDate = '' + finalDay + '/' + finalMonth + '/' + year + '';
        return finalDate;
    }

    render() {
        let lang = this.props.lang;
        let itemCount = 0;
        let itemSum = 0;
        let rowColor = '';
        let tableDir = "rtl";
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth();
        let day = date.getDate();
        //console.log('this.props.finalOfferItems: ', this.props.finalOfferItems);
        let currency = this.props.currency === 'ILS' ? langConf[lang].ILS : langConf[lang].USD;
        
        if (lang === 'english') {
            tableDir = "ltr";
        }
        this.props.finalOfferItems.map((item) => itemCount += item.quantity);
        this.props.finalOfferItems.map((item) => itemSum += this.props.currency === "ILS" ? (item.priceNis === null ? 0 : (item.priceNis * item.quantity)) : (item.Usd === null ? 0 : (item.priceUsd * item.quantity)));
        let index = 0;
        const items = this.props.finalOfferItems.map((item) => {
            index++;
            if (item.category === 999) {
                rowColor = 'ui blue right table';
            }
            let d = new Date(item.cartItemDate);
            return (
                <tr key={`${index}.  ${item.itemNo}`} className={`${rowColor}`} style={{ textAlign: 'center' }} >
                    <td style={{ display: 'none' }}>{item.itemNo}</td>
                    <td style={{textAlign: 'center'}} data-label={langConf[lang].orderDate}>{`[${item.cartItemDate === undefined ? this.NormalizeDateIL(day, month, year) : this.NormalizeDateIL(d.getDate(), d.getMonth(),d.getFullYear())}]`}</td>
                    <td style={{textAlign: 'center'}} data-label={langConf[lang].itemName}>{lang === 'hebrew' ? item.hebName : item.engName}</td>
                    <td style={{textAlign: 'center'}} data-label={langConf[lang].quantity}>{item.quantity}</td>
                    <td style={{textAlign: 'center'}} data-label={langConf[lang].price}>{`${this.numberWithCommas(this.props.currency === "ILS" ? ((item.priceNis === null || item.priceNis === '' ? 0 : item.priceNis) * item.quantity) : ((item.priceUsd === null || item.priceUsd === '' ? 0 : item.priceUsd) * item.quantity))} ${currency}`}</td>
                </tr>
            )
        });
        return (
            <div className="col-12 panel panel-info" style={{}}>
                <div className='panel-heading'>{langConf[lang].finalOffer}</div>
                <div className="col-12">
                    <table className={`table table-hover table-responsive`} dir={tableDir} style={{ textAlign: langConf[lang].right}}>
                        <thead>
                            <tr>
                                <th style={{ display: 'none', textAlign: 'center' }}>{langConf[lang].itemNo}</th>
                                <th style={{textAlign: 'center'}}>{langConf[lang].orderDate}</th>
                                <th style={{textAlign: 'center'}}>{langConf[lang].itemName}</th>
                                <th style={{textAlign: 'center'}}>{langConf[lang].quantity}</th>
                                <th style={{textAlign: 'center'}}>{langConf[lang].price}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th style={{textAlign: 'center'}}></th>
                                <th style={{textAlign: 'center'}}>{langConf[lang].subtotal}</th>
                                <th style={{textAlign: 'center'}}>{`${itemCount} ${langConf[lang].items}`}</th>
                                <th style={{textAlign: 'center'}}>{`${this.numberWithCommas((itemSum === null ? 0 : itemSum))} ${currency}`}</th>
                            </tr>
                        </tfoot>
                    </table>

                </div>
                <div className={`col-6`} style={lang === 'hebrew' ? { float: 'right', marginTop: '5px' } : { float: 'left', marginTop: '5px' }}>
                    <BackButton
                        //Globals
                        lang={lang}
                        currentURL={this.props.currentURL}
                        //Methods
                        onClick={(event) => { event.preventDefault(); this.props.changeScreen('cart') }}
                    />
                </div>
                <div className={`col-6`}>
                <a href={this.props.currentURL} className="btn btn-success btn-lg btn-block" style={lang === 'hebrew' ? { float: 'left', marginTop: '5px' } : { float: 'right', marginTop: '5px' }} onClick={this.handleClick}>{langConf[lang].toPayment}</a>
                </div>
                {/* <div className={`ui large input ${lang}`} id="coupon" style={lang === 'hebrew' ? { float: 'left', marginTop: '5px', display: 'none' } : { float: 'right', marginTop: '5px', display: 'none' }}>
                    <input type="text" placeholder={langConf[lang].coupon} style={lang === 'hebrew' ? { textAlign: 'right', marginRight: '3px', height: '36px' } : { textAlign: 'left', marginLeft: '3px' }}></input>
                    <button className={`ui blue button ${lang}`} id="submitCoupon" style={lang === 'hebrew' ? { float: 'left' } : { float: 'right' }} onClick={this.handleCouponSubmitClick}>{langConf[lang].submit}</button>
                </div>
                <button className={`ui blue button ${lang}`} style={lang === 'hebrew' ? { float: 'left', marginTop: '5px' } : { float: 'right', marginTop: '5px' }} onClick={this.handleCouponClick}>{langConf[lang].iHaveACoupon}</button> */}

            </div>
        );
    }
}

export default FinalOffer;
